import Card from './card'

Card.install = vue => vue.component(Card.name, Card)

export default Card
